import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

Bugsnag.start({
  apiKey: '18b6a2651e9f85aef9de459447075dc3',
  plugins: [new BugsnagPluginVue()]
})

export default Bugsnag
